/*----------------------------------------------------------------------------------------
This dropdown filter is to be used with JsCarousel, but you can use it anywhere really

let filter = new DropdownFilter([
        {
            title: 'Option 1',
            value: 1,
        },
        {
            title: 'Option 2',
            value: 2,
        },
    ]);

** If there're already content for filter, you can call constructor with no options; The filter will automatically parse the options

let filter = new DropdownFilter();


filter.setMount($('#filter-mount-div')) // required
    .setSelectedIndex(0) // required
    .build();

----------------------------------------------------------------------------------------
                    __
 ___ _  _____ ___  / /____
/ -_) |/ / -_) _ \/ __(_-<
\__/|___/\__/_//_/\__/___/

----------------------------------------------------------------------------------------

$(filter).on('filterSelected', (e, index, value) => {
        console.log('You selected', value);
    });

- `filterSelected`
Arguments: index, value
Fires after filter option is selected

----------------------------------------------------------------------------------------*/

import template from 'templates/filters/__filter.tpl';

export default class DropdownFilter {
    constructor(options = {}) {
        this._ = null;
        this.options = options;
        this.selectedInd = 0;
    }

    build() {
        if (!this.__isDomEmpty(this._)) {
            // if filter already has content, don't render
            this.__parseOptionsFromDom();
        } else {
            // otherwise, render filters
            this.__render();
        }

        this.__postRun();

        this.__eventListeners();

        //START A/B TEST PLGRWEB-1657-Fav Five Seasons
        if (CBS.AbTestsConfigs?.modules?.ShowPageFanFaveSeasons?.inVariants) {
            (async () => {
                const faveSeasons = (await import(`abTests/testClasses/ShowPageFanFaveSeasons`))
                    .default;
                this.faveSeasons = new faveSeasons();
            })();
        }
        //END A/B TEST PLGRWEB-1657-Fav Five Seasons
    }

    setMount(el) {
        this._ = el;
        return this;
    }

    setOptions(options) {
        this.options = options;

        return this;
    }

    setSelectedIndex(selectedIndex) {
        this.selectedInd = selectedIndex;

        return this;
    }

    getSelectedIndex() {
        return this.selectedInd;
    }

    getSelectedOption() {
        if (this.selectedInd < this.options.length) {
            return this.options[this.selectedInd];
        }

        return false;
    }

    __setDropDownHoverElement() {
        // this is the element a user will hover (click on mobile) to open the dropdown
        this.elDropdownHover = this._.find('.pv-h');
        return this;
    }

    __isDomEmpty(el) {
        return !$.trim(el.html());
    }

    __parseOptionsFromDom() {
        let options = [];

        this._.find('ul.content li a').each((ind, el) => {
            let t = {
                title: $(el).text(),
                value: $(el).data('value'),
            };
            options.push(t);

            if ($(el).data('selected')) {
                this.selectedInd = $(el).data('index');
            }
        });

        this.options = options;
    }

    __postRun() {
        this.__setDropDownHoverElement();

        // if there's only select option, disable dropdown animation
        if (this.options.length === 1) {
            // remove selectable option
            this._.find('ul.content').remove();
            // remove caret & clickable
            this._.find('a.js-filter').addClass('no-caret').css('pointer-events', 'none');
        }
    }

    __eventListeners() {
        let self = this;
        // On hover, element doesn't have focus so a keyboard listener does not work. Escape key will close the menu
        document.addEventListener('keyup', (e) => {
            const keyCode = e.keyCode || e.which;
            if (self.elDropdownHover.hasClass('hover') && keyCode === 27) {
                self.elDropdownHover.removeClass('hover');
            }
        });
        // invoke the dropdown
        this._.find('li.pv-h a').on('focus', (e) => {
            e.preventDefault();
            e.stopPropagation();
            self.elDropdownHover.addClass('hover');

            /* need to refine so that it points to only the current object */
            $('select.dropdown__filter__fake').attr('tabindex', '-1');
        });

        // invoke the dropdown
        this._.find('li.pv-h button').on('focus', (e) => {
            e.preventDefault();
            e.stopPropagation();
        });

        // hide the dropdown
        this._.find('li.pv-h button').on('blur', (e) => {
            e.preventDefault();
            e.stopPropagation();
            self.elDropdownHover.find('button').attr('aria-expanded', false);
            self.elDropdownHover.removeClass('hover');
        });

        // invoke the dropdown
        this._.find('li.pv-h').on('mouseover', (e) => {
            if (!CBS.Registry.platform.isMobile) {
                e.preventDefault();
                e.stopPropagation();
                self.elDropdownHover.addClass('hover');
            }
        });

        // hide the dropdown from hover
        this._.find('li.pv-h').on('mouseleave', (e) => {
            if (!CBS.Registry.platform.isMobile) {
                e.preventDefault();
                e.stopPropagation();
                self.elDropdownHover.removeClass('hover');
            }
        });

        // handle dropdown on mobile
        if (CBS.Registry.platform.isMobile) {
            this._.find('li.pv-h button').on('touchstart click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                self.elDropdownHover.toggleClass('hover');
            });
        }

        // drop down items
        this._.find('ul.content a').on('click', (e) => {
            e.preventDefault();
            e.stopPropagation();

            //START A/B TEST PLGRWEB-1657-Fav Five Seasons
            if (this.faveSeasons) {
                const { isSwitchingSeason, targetElement, faveIcon } =
                    this.faveSeasons.getSeasonDropDownElement(e.target);
                if (!isSwitchingSeason) {
                    return;
                }
                e.target = targetElement;
                e.faveIcon = faveIcon;
            }
            //END A/B TEST PLGRWEB-1657-Fav Five Seasons

            self.__selectedHandler(e);
            self.elDropdownHover.toggleClass('hover');

            // trick dropdown to kill expand animation on tablet
            self.elDropdownHover.removeClass('hover');
        });

        // drop down items - keyboard press enter key
        this._.find('ul.content a').on('keydown', (e) => {
            var keyCode = e.keyCode || e.which;
            if (keyCode === 13) {
                $(this).click();
            }
        });

        // proxy event handler for dropdown fake
        this._.find('.dropdown__filter__fake').on('change', (e) => {
            e.preventDefault();
            e.stopPropagation();

            let currentVal = $(e.target).val();
            self._.find('ul.content a[data-value="' + currentVal + '"]').trigger('click');
        });

        // invoke the dropdown with using keyboard enter key
        this._.find('li.pv-h').on('keydown', (e) => {
            let keyCode = e.keyCode || e.which;
            // enter (13): display the list; tab (9): skip or jump on the list if it's opened
            if (keyCode === 13) {
                $(this).click();
                if (self.elDropdownHover.hasClass('hover')) {
                    self.elDropdownHover.find('button').attr('aria-expanded', false);
                    // to hide the list
                    self.elDropdownHover.removeClass('hover');
                } else {
                    // to show the list
                    self.elDropdownHover.find('button').attr('aria-expanded', true);
                    self.elDropdownHover.addClass('hover');
                }
            } else if (keyCode === 9) {
                if (self.elDropdownHover.hasClass('hover')) {
                    // enable the dropdown list items
                    self.elDropdownHover.find('button').attr('aria-expanded', false);
                    self.elDropdownHover.find('li a').attr('tabindex', '0');
                    // show the dropdown list
                    self.elDropdownHover.removeClass('hover');
                } else {
                    // to show the list
                    self.elDropdownHover.addClass('hover');
                    self.elDropdownHover.find('button').attr('aria-expanded', true);
                }
            }
        });
    }

    __selectedHandler(e) {
        let self = this;
        let t = $(e.target);
        let selectedDom = this._.find('.js-filter').first();

        // if select the same option, don't trigger the event
        if (self.selectedInd !== t.data('index')) {
            selectedDom.text(t.text());

            //START A/B TEST PLGRWEB-1657-Fav Five Seasons
            if (this.faveSeasons) {
                const parts = t.text().trim().split(' ');
                selectedDom.html(`${parts[0]} ${parts[1]}${e.faveIcon.outerHTML ?? ''}`);
            }
            //END A/B TEST PLGRWEB-1657-Fav Five Seasons

            $(self).trigger('filterSelected', [
                t.data('index'),
                self.options[t.data('index')].value,
            ]);
        }

        // Remove data-selected from the previously selected element and add it to the new one
        const selectedSeasons = this._[0].querySelectorAll('a[data-selected="true"]');
        selectedSeasons.forEach((selectedSeason) => {
            selectedSeason.removeAttribute('data-selected');
        });
        t[0].setAttribute('data-selected', 'true');

        self.selectedInd = t.data('index');
    }

    __render() {
        if (this.options.length > 0 && this.selectedInd < this.options.length) {
            let self = this;
            this._.append(
                $(
                    template({
                        data: self.options,
                        selected: self.options[self.selectedInd],
                    }),
                ),
            );
        }
    }
}
